/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import { editAd } from "../../../../../store/advertisement/advertisement-action";
import { resetEditAdItem } from "../../../../../store/advertisement/advertisement-reducer";
import {
  createPopupBanner,
  editPopUpBanner,
  getAllPopupBanner,
} from "../../../../../store/addPopupBannes/addPopupBanner.action";

type Props = {
  className: string;
};

export interface mydata extends FormData {
  id?: string;
  _id?: string;
  title?: string;
  description?: string;
  link?: string;
  active?: boolean;
}

// interface IEditITem  {
//   item: IEngageWidget10InitValues;
//   isEdit?: boolean;
// }
const EngageWidget11 = ({ className }: Props) => {
  const editAdItem = useAppSelector(
    (state) => state.createAdReducer.itemToBeEdit
  );
  const [title, setTitle] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [id, setId] = useState("");
  const [description, setDescription] = useState("");
  const [banner, setBanner] = useState<File | null>(null);
  const [link, setLink] = useState("");
  const [error, setError] = useState(true);
  const [isValid, setIsValid] = useState(true);
  const [scrollTop, setScrollTop] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const validateUrl = (value: string) => {
    if (!value || value.trim() === "") {
      return false; // Empty or whitespace input is considered invalid
    }
    const urlPattern =
      /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,6}\.?)(\/[\w\-.\[\]\~\:\/\?\#\@\!\$\&\'\(\)\*\+\,\;\=\%]*)?$/i;
    return urlPattern.test(value);
  };

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editAdItem) {
      setTitle(editAdItem?.item?.title || "");
      setDescription(editAdItem?.item?.description || "");
      setLink(editAdItem?.item?.link || "");
      setId(editAdItem?.item?._id || "");
      setBanner(editAdItem?.item?.banner || null);
      setIsEdit(editAdItem.isEdit || false);
      setCurrentPage(editAdItem.currentPage || 0);
      setScrollTop(true);
    }
  }, [editAdItem]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isEdit) {
      if (link) {
        const payload = {
          id: id,
          title: title,
          description: description,
          url: link,
        };

        dispatch(editPopUpBanner(payload));
        dispatch(getAllPopupBanner({ page: currentPage }));
        dispatch(resetEditAdItem({ item: {}, isEdit: false, currentPage: 0 }));

        setBanner(null);
        setDescription("");
        setLink("");
        setTitle("");
        setIsValid(true);
      } else {
        setError(false);
      }
    } else {
      const payload = {
        title: title,
        description: description,
        url: link,
        createdBy: "680e3522870755ea1de27973",
      };
      dispatch(createPopupBanner(payload));
      dispatch(getAllPopupBanner({ page: 1 }));

      setBanner(null);
      setDescription("");
      setLink("");
      setTitle("");
      setIsValid(true);
    }
  };

  useEffect(() => {
    if (scrollToTop) {
      scrollToTop();
      setScrollTop(false);
    }
  }, [scrollTop]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const resetHandler = () => {
    setBanner(null);
    setDescription("");
    setLink("");
    setTitle("");
    setIsValid(true);
    dispatch(resetEditAdItem({ item: {}, isEdit: false }));
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setError(true);
    if (file) {
      setBanner(file);
    }
  };
  return (
    <form
      className="form w-100"
      onSubmit={handleSubmit}
      // noValidate
      // id="kt_login_signin_form"
    >
      <div style={{ backgroundColor: "#000F1E" }} className="card row mb-6">
        <div
          className="card-header border-0 cursor-pointer"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target="#kt_account_profile_details"
          aria-expanded="true"
          aria-controls="kt_account_profile_details"
        >
          <div className="card-title m-0">
            <h3 className="fw-bolder m-0">Add Popup banners</h3>
          </div>
        </div>

        <div className="col-lg px-9">
          <div className="row">
            <div className="col-lg-6 fv-row">
              <label className=" pb-5 fs-6">Banner Title</label>
              <input
                style={{ backgroundColor: "#000810", padding: "12px 10px" }}
                className="form-control form-control-lg  mb-3 mb-lg-0"
                placeholder="Enter banners title..."
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                type="text"
                name="title"
              />
            </div>

            <div className="col-lg-6 fv-row">
              <label className="pb-5 fs-6">Redirect Link</label>
              <select
                required
                style={{
                  backgroundColor: "#000810",
                  padding: "12px 10px",
                  color: "#fff",
                }}
                className="form-control form-control-lg"
                value={link}
                onChange={(e) => {
                  setLink(e.target.value);
                  setError(true);
                  // setIsValid(e.target.value === "" || validateUrl(e.target.value));
                }}
                name="link"
              >
                <option value="">Select redirect screen</option>
                <option value="/notification">Notifications</option>
                <option value="/aboutus">About Us</option>
                <option value="/category">Categories</option>
                <option value="/changePassword">Change Password</option>
                <option value="/mapScreenForPetRefliefAreas">
                  Pet Relief Map
                </option>
                <option value="/profileScreen">Profile</option>
                <option value="/settingsScreen">Settings</option>
                <option value="/scanQRCodeScreen">Scan QR Code</option>
                <option value="/tODOListScreen">To-Do List</option>
                <option value= "/subscriptionScreen">Subscription screen</option>
              </select>

              {!isValid && <p className="text-danger">Invalid URL format</p>}
            </div>

            <div className="col-lg-6 fv-row">
              <label className=" pb-5 py-5 fs-6">Banner Description</label>
              <textarea
                style={{ backgroundColor: "#000810" }}
                className="form-control form-control pt-2 pb-13 form-control-solid"
                placeholder="Enter Popup banners description..."
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                name="description"
              />
            </div>
          </div>
          <div className="col-lg-6 py-5 fv-row">
            <button
              type="submit"
              style={{ backgroundColor: "#00874F" }}
              className="btn fw-bolder"
            >
              {isEdit ? "Update Banner" : " Upload Banner"}
            </button>

            {isEdit && (
              <button
                type="button"
                onClick={resetHandler}
                style={{ backgroundColor: "#00874F" }}
                className="btn fw-bolder ms-3"
              >
                Reset
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};
export { EngageWidget11 };
